import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, FileText, Receipt, BookOpen, Users } from 'lucide-react';

const tabs = [
  { to: '/', icon: LayoutDashboard, label: 'Home' },
  { to: '/invoices', icon: FileText, label: 'Invoices' },
  { to: '/receipts', icon: Receipt, label: 'Receipts' },
  { to: '/voucher-entries', icon: BookOpen, label: 'Vouchers' },
  { to: '/parties', icon: Users, label: 'Parties' },
];

export default function MobileBottomNav() {
  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 dark:bg-[hsl(260,15%,8%,0.95)] backdrop-blur-lg border-t border-purple-100 dark:border-purple-900/30 safe-area-bottom" data-testid="mobile-bottom-nav">
      <div className="flex items-center justify-around px-1 py-1">
        {tabs.map(t => (
          <NavLink key={t.to} to={t.to} end={t.to === '/'}
            className={({ isActive }) => `flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg transition-all min-w-[56px] ${isActive ? 'text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-900/30' : 'text-slate-400 dark:text-slate-500'}`}
            data-testid={`bottom-nav-${t.label.toLowerCase()}`}>
            <t.icon className="w-5 h-5" strokeWidth={1.8} />
            <span className="text-[10px] font-semibold leading-tight">{t.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
